// IMPORTANT: Make sure this is in sync with functions/src/index.ts -> prepareDailyDigest
export enum EDITOR_CONTEXT_TYPE {
    post = 'post',
    annotation = 'annotation',
}
